<template>

  <i
    :class="currentClass"
    aria-hidden="true"
    @click="sort()"
    style="cursor:pointer;"
  />

</template>

<script>
import Utils from "../mixins/ObjectUtilsMixin";

export default {
    mixins: [Utils],

    props: {
        list: {},
        field: {},

        classDesc: {
            default: 'fa fa-sort ml-3',
            type: String,
        },

        classAsc: {
            default: 'fa fa-sort ml-3',
            type: String,
        },
    },

    data() {
        return {
            asc: true,
        };
    },

    computed: {
        currentClass: function() {
            return this.asc ? this.classAsc : this.classDesc;
        },
    },

    methods: {
        sort() {
            if (this.asc) {
                this.sortAsc();
            } else {
                this.sortDesc();
            }

            this.asc = !this.asc;
        },

        sortAsc() {
            this.list.sort((a, b) => {
                let values = this.convert(a, b);

                if (values[0] === values[1]) {
                    return 0;
                }

                return values[0] < values[1] ? -1 : 1;
            });
        },

        sortDesc() {
            this.list.sort((a, b) => {
                let values = this.convert(a, b);

                if (values[0] === values[1]) {
                    return 0;
                }

                return values[0] > values[1] ? -1 : 1;
            });
        },

        convert(a, b) {
            let val1 = this.dotGet(this.field, a);
            let val2 = this.dotGet(this.field, b);

            // datetime works automatically since ISO timestamp format
            // eg. 2018-01-22 12:31:36 will sort correctly as string
            // add convert for other formats (convert to ticks or seconds from unix epoch etc...)

            if (typeof val1 === 'string' && typeof val2 === 'string') {
                val1 = val1.toLowerCase();
                val2 = val2.toLowerCase();
            }

            return [val1, val2];
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table-components/SortButtonComponent.vue